import { onMounted, onUnmounted } from 'vue'

export default function useAutoRefresh(refresh, shouldPoll, intervalMs = 15000) {
    let timer = null
    let running = false

    const run = async () => {
        if (running || document.visibilityState !== 'visible') return

        running = true

        try {
            await refresh()
        } catch (error) {
            return
        } finally {
            running = false
        }
    }

    const onVisibilityChange = () => {
        if (document.visibilityState !== 'visible') return

        run()
    }

    const onTick = () => {
        if (! shouldPoll()) return

        run()
    }

    onMounted(() => {
        document.addEventListener('visibilitychange', onVisibilityChange)
        window.addEventListener('focus', run)
        timer = setInterval(onTick, intervalMs)
    })

    onUnmounted(() => {
        document.removeEventListener('visibilitychange', onVisibilityChange)
        window.removeEventListener('focus', run)
        clearInterval(timer)
    })

    return { run }
}
